function Razor() {

  return (
    <div className="App">
      <button >Click</button>
    </div>
  );
}
export default Razor;